import { render, staticRenderFns } from "./BlanSpace.vue?vue&type=template&id=e0f8925e&scoped=true&"
import script from "./BlanSpace.vue?vue&type=script&lang=js&"
export * from "./BlanSpace.vue?vue&type=script&lang=js&"
import style0 from "./BlanSpace.vue?vue&type=style&index=0&id=e0f8925e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0f8925e",
  null
  
)

export default component.exports